import { Box, Text, Flex } from '@chakra-ui/react';
import {useTranslation} from "react-i18next";

const RegisterSuccess = () => {
    const {t} = useTranslation("default");

    return (
        <Flex minH={{ base: 'calc(100vh - 64px)', md: 'calc(100vh - 72px)' }} align="center" justify="center" bg="#F8F5F4" px={4}>
            <Box textAlign="center" maxW="520px" w="full" bg="white" border="1px solid #ECE4E4" borderRadius="22px" boxShadow="0 1px 2px rgba(14,26,23,0.04), 0 16px 40px rgba(14,26,23,0.07)" p={{ base: '24px', md: '40px' }} my={{ base: '24px', md: '56px' }}>
                <Text fontFamily="heading" fontSize="28px" fontWeight="700" letterSpacing="-0.5px" mb={3}>
                    {t('register.success.title')}
                </Text>
                <Text fontSize="lg">
                    {t('register.success.message')} <br />
                    {t('register.success.message2')}
                </Text>
            </Box>
        </Flex>
    );
};

export default RegisterSuccess;
